import { securityCreateToken/*, getProfile*/, refreshApiToken, makeLogout, getPermissions } from 'utils/api';
import { SET_AUTH, SET_PROFILE, LOG_OUT, SET_PERMISSIONS } from './types';
import moment from 'moment';
import { removeState } from '../../localStorage';
import store from 'redux/configureStore';

// export function setProfile() {
//     return dispatch => {
//         return getProfile().then(res => {  
//             dispatch({
//                 type: SET_PROFILE,
//                 data: res.content
//             });
//         });
//     };
// }

export function setPermissions() {
    // return dispatch => {
    //     dispatch({
    //         type: SET_PERMISSIONS,
    //         data: ['vs', 'social']     //'vs', 'social'
    //     });
    return dispatch => {
        getPermissions().then(res => {
            dispatch({
                type: SET_PERMISSIONS,
                permissions: res.content.permissions,
                isSingleUser: res.content.isSingleUser,
                accountName: res.content.accountName,
            });
        });
    }
}

export function updatePermissions(data) {
    // return dispatch => {
    //     dispatch({
    //         type: SET_PERMISSIONS,
    //         data: ['vs', 'social']     //'vs', 'social'
    //     });
    return dispatch => {
        dispatch({
            type: SET_PERMISSIONS,
            permissions: data.permissions,
            isSingleUser: data.isSingleUser,
            accountName: data.accountName,
        })
    };
}

export function logout() {
    if(store.getState().auth.isAuthenticated) {
        return dispatch => {
            // makeLogout()
            // .then(() => {
            console.log('logging out')
                removeState();
                dispatch({ type: LOG_OUT });
                // let globalDomain = new URL(window.location.href).hostname;
                // if(globalDomain === 'nftst-app.dataprodev.com') {
                //     window.location.assign('https://nftst-app.dataprodev.com/sign-in/');
                // } else if(globalDomain === 'app.newsfetch.io') {
                //     window.location.assign('https://app.newsfetch.io/sign-in/');
                // } else if(globalDomain === '0.0.0.0') {
                //     window.location.assign('http://0.0.0.0:7070/sign-in/');
                // } else if(globalDomain === 'localhost') {
                //     window.location.assign('localhost/sign-in/');
                // }
            // })
            // .catch(err => {
            //     removeState();
            //     dispatch({ type: LOG_OUT });
            //     let globalDomain = new URL(window.location.href).hostname;
            //     if(globalDomain === 'nftst-app.dataprodev.com') {
            //         window.location.assign('https://nftst-app.dataprodev.com/sign_in/');
            //     } else if(globalDomain === 'app.newsfetch.io') {
            //         window.location.assign('https://app.newsfetch.io/sign_in/');
            //     } else if(globalDomain === '0.0.0.0') {
            //         window.location.assign('http://0.0.0.0:7070/#/sign_in/');
            //     }
            // });
        };
    }
}

export function logoutWithoutRedirect() {
    if(store.getState().auth.isAuthenticated) {
        return dispatch => {
            // makeLogout()
            // .then(() => {
                removeState();
                dispatch({ type: LOG_OUT });
            // })
            // .catch(err => {
            //     removeState();
            //     dispatch({ type: LOG_OUT });
            // });
        };
    }
}

export function login(username, password) {
    return dispatch => {
        const params = {
            _username: username,
            _password: password,
        };

        return securityCreateToken(params)
            .then(res => {
                const now = moment().format('YYYY-MM-DDTHH:mm:ssZ');
                const then = res.datetime;
                const timeOffset =
                    moment(now, 'YYYY-MM-DDTHH:mm:ssZ').diff(
                        moment(then, 'YYYY-MM-DDTHH:mm:ssZ')
                    ) / 1000;
                const authData = {
                    username: username,
                    wsseToken: res.content.token,
                    permissions: res.content.userData.permissions.permissions,
                    isSingleUser: res.content.userData.isSingleUser,
                    accountName: res.content.userData.accountName,
                    timeOffset,
                };
                dispatch({type: SET_AUTH, data: authData});
            })
    };
}

export function refreshTokenAction() {
    return dispatch => {
        return refreshApiToken({ _token: store.getState().auth.wsseToken.refreshToken })
            .then(res => {
                const now = moment().format('YYYY-MM-DDTHH:mm:ssZ');
                const then = res.datetime;
                const timeOffset =
                    moment(now, 'YYYY-MM-DDTHH:mm:ssZ').diff(
                        moment(then, 'YYYY-MM-DDTHH:mm:ssZ')
                    ) / 1000;
                const authData = {
                    ...store.getState().auth,
                    wsseToken: res.content.token,
                    timeOffset
                };               
                dispatch({type: SET_AUTH, data: authData});
            })
            /*.catch((error) => {
                makeLogout()
                    .then(() => {
                        removeState();
                        dispatch({ type: LOG_OUT });
                    })
                    .catch(err => {
                        removeState();
                        dispatch({ type: LOG_OUT });
                    });
            });*/
    };
}